import { useCallback, useEffect, useRef } from "react";
import { isProduction } from "../services/serviceConfig";
import { isVersionUK } from "../services/versionService";

const DATA_APP_ID_DEV = "d1b96d81-22f0-47f0-b343-0d8b29a8cad5";
const DATA_APP_ID_PROD_UK = "d1b96d81-22f0-47f0-b343-0d8b29a8cad5";
const DATA_APP_ID_PROD_US = "";

const DATA_APP_ID = isProduction ? (isVersionUK ? DATA_APP_ID_PROD_UK : DATA_APP_ID_PROD_US) : DATA_APP_ID_DEV;
const DATA_ORG_URL = "https://m-ae577d84-687b-48e5-a266-de3339d0875f.uk.omnichannelengagementhub.com";

export const useOmnichannelWidget = () => {
    const { current: script } = useRef(document.createElement("script"));
    const isScriptAdded = useRef(false);

    const appendScript = useCallback(() => {
        if (!script || isScriptAdded.current) return;

        script.id = "Microsoft_Omnichannel_LCWidget";
        script.src = "https://oc-cdn-public-gbr.azureedge.net/livechatwidget/scripts/LiveChatBootstrapper.js";
        script.setAttribute("data-app-id", DATA_APP_ID);
        script.setAttribute("data-lcw-version", "prod");
        script.setAttribute("data-org-id", "ae577d84-687b-48e5-a266-de3339d0875f");
        script.setAttribute("data-org-url", DATA_ORG_URL);

        document.head.appendChild(script);
        isScriptAdded.current = true;
    }, [script, isScriptAdded]);
    const removeScript = useCallback(() => {
        if (!script || !isScriptAdded.current) return;
        document.head.removeChild(script);
        isScriptAdded.current = false;
    }, [script, isScriptAdded]);

    useEffect(() => {
        appendScript();
    }, [appendScript, removeScript]);
};
